import { createContext } from 'react';

export interface LookUpData {
  phoneNumber?: string;
  flow?: string;
  locked?: boolean;
  lockoutExpiryTime?: string;
  lookupId?: string;
  emailAddress?: string;
  currentEmailAddress?: string;
  mfa: {
    communicationDetails: [];
    mnoEnabled: boolean;
    mfaOTPSessionKey: string;
  };
  accountInfos?: [
    {
      internalID: string;
      userID: string;
    }
  ];
  patientInfo?: {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    phoneNumber: string;
    streetAddress?: string;
    unit?: string;
    city?: string;
    state?: string;
    zipCode?: string;
    memberID?: string;
  };
  personalInfoFormFlag?: boolean;
  addressInfoFormFlag?: boolean;
  phoneDOBInfoFormFlag?: boolean;
  onlyDOBFieldFlag?: boolean;
  onlyDOBFieldLastAttemptFlag?: boolean;
  pbmUserFormFlag?: boolean;
  showMemberId?: boolean;
  communicationDetails: [
    {
      key: string;
      value: string;
    }
  ];
  appProps?: {
    returnUrl?: string;
    mfaRequired?: boolean;
    mfaAdobeTenantSection?: string;
    adobeFlowName: string;
    source: string;
    flow?: string;
    title: string;
    description: string;
    addrTitle: string;
    addrDescription: string;
    showCardLink?: boolean;
    showDemoLink?: boolean;
    continueUrl?: string;
    keepQueryAfterLookup?: boolean;
    consumerName?: string;
    isThirdParty?: boolean;
  };
}

export interface ContextInterface {
  lookupData: LookUpData;
  updateLookupData: (value: any) => void;
}

const Context = createContext<ContextInterface | null>(null);

export default Context;
